
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import MomentMixin from '@/_mixins/moment'
import UserMixin from '@/_mixins/user'
import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import NotificationGroupComponent from '@/views/Notification/components/notificationGroup.vue'
import NotificationGroupModel from '@/views/Notification/models/notificationGroup'

import { notificationBaseUrl } from '@/utils/axios'
import { postRequest } from '@/plugins/api-axios'
import lodash from 'lodash'
import { getRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'

import { deserialise } from 'kitsu-core'

const Notifications = Vue.extend({
    mixins: [AppMixin, MomentMixin, UserMixin],
    components: { ToolbarComponent, NotificationGroupComponent },
    data() {
        return {
            notificationGroups: [] as Array<NotificationGroupModel>,
            read: false,
            limit: 20,
            infiniteID: 1,
            markAllAsReadDialog: false,
            loadingMarkedAsRead: false,
            notificationUser: null as null | Record<string, any>,
        }
    },

    computed: {
        leTime() {
            return this.notificationGroups.length == 0
                ? this.iso8601()
                : this.notificationGroups[this.notificationGroups.length - 1].leTime
        },
        leReadAt() {
            return this.notificationGroups.length == 0
                ? this.iso8601()
                : this.notificationGroups[this.notificationGroups.length - 1].leReadAt
        },
        canMarkAllNotificationsAsRead() {
            return this.notificationUser?.canMarkAllNotificationsAsRead || false
        },
    },
    methods: {
        async getNotificationUser() {
            if (!this.currentUser.id) return

            const { data } = await getRequest(
                getURL({
                    path: `users/${this.currentUser.id}`,
                    base: process.env.VUE_APP_NOTIFICATION_BASE_URL,
                    params: {},
                })
            )

            if (data) this.notificationUser = deserialise(data).data
        },
        setUnreadNotifications() {
            this.$store.commit('hasUnreadNotifications', this.notificationGroups.length > 0)
        },
        markedAsRead(index) {
            this.notificationGroups.splice(index, 1)
            this.setUnreadNotifications()
        },
        async markAllAsRead() {
            this.loadingMarkedAsRead = true
            await postRequest(
                `${notificationBaseUrl}/users/${this.currentUser.id}/markAllNotificationsAsRead`,
                null,
                {
                    ...(this.isProject && { 'filter[project]': this.currentProjectId }),
                    ...(this.isGroup && { 'filter[projectGroup]': this.currentGroup.id }),
                }
            )
            this.notificationGroups = []
            this.markAllAsReadDialog = false
            this.loadingMarkedAsRead = false
            this.setUnreadNotifications()
        },
        infiniteHandler: lodash.debounce(async function ($state) {
            let query = {
                include: ['topNotifications.actingUser', 'resource'],
                filters: {
                    'filter[read]': this.read,
                    'page[limit]': this.limit,
                    ...(this.isProject && { 'filter[project]': this.currentProjectId }),
                    ...(this.isGroup && { 'filter[projectGroup]': this.currentGroup.id }),
                    ...(this.read && { 'filter[readAt][le]': this.leReadAt }),
                    ...(!this.read && { 'filter[time][le]': this.leTime }),
                },
            }

            let res = await NotificationGroupModel.search(query)

            this.notificationGroups.push(...res)
            this.notificationGroups = this.lodash.uniqBy(this.notificationGroups, '_id')

            if (Object.keys(res).length == this.limit) {
                $state.loaded()
            } else {
                $state.complete()
            }
        }),
        refreshInfinite() {
            this.notificationGroups = []
            this.infiniteID++
        },
        isObject(value) {
            return value !== null && typeof value === 'object'
        },
        saveNotificationsLastRead() {
            let notificationsLastRead = this.$store.getters.frontEndSettings?.notificationsLastRead
            if (!this.isObject(notificationsLastRead)) {
                notificationsLastRead = {}
            }

            let frontEndSettings = {
                ...(this.$store.getters.frontEndSettings && {
                    ...this.$store.getters.frontEndSettings,
                }),
                notificationsLastRead: {
                    ...notificationsLastRead,
                    [this.isGroup ? this.currentGroup.id : this.currentProjectId]: this.iso8601(),
                },
            }
            this.$store.commit('frontEndSettings', frontEndSettings)

            this.handlePatchUser({
                updatedAt: this.$store.getters.user?.attributes.updatedAt,
                data: {
                    id: this.currentUser.id,
                    type: 'user',
                    attributes: {
                        frontEndSettings: JSON.stringify(this.$store.getters?.frontEndSettings),
                    },
                },
            })

            this.$store.commit('hasUnreadNotifications', false)
        },
        handlePatchUser(params: any) {
            this.patchUser(params).catch(async (error: any) => {
                if (error.data.response.status === 412) {
                    let res = await this.getUser(this.$store.getters.user.id).catch(() => {
                        //
                    })

                    params.updatedAt = this.$store.getters.user?.attributes.updatedAt

                    this.handlePatchUser(params)
                }
            })
        },
    },

    watch: {
        read() {
            this.refreshInfinite()
        },
        '$store.state.notification.hasUnreadNotifications': function (yes) {
            if (yes && this.notificationGroups.length === 0) {
                this.refreshInfinite()
            } else if (!yes && this.notificationGroups.length > 0) {
                this.notificationGroups = []
            }
        },
    },

    mounted() {
        this.getNotificationUser()
        this.saveNotificationsLastRead()
    },
})
export default Notifications
